import { useContext } from 'react';

import { Context } from '../context';

export const useAction = () => {
  const data = useContext(Context);

  return data;
};
